import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { JdData } from '../common-interfaces-classes/JdData';
import { SearchtoolboxService } from '../_services/searchtoolbox.service';
import { AiSourcingService } from '../_services/ai-sourcing.service';
import { PersonSearchService } from '../_services/person-search.service';
import { JdDataService } from '../jd-data.service';
@Component({
    selector: 'app-gen-ai-jd-search',
    templateUrl: './gen-ai-jd-search.component.html',
    styleUrls: ['./gen-ai-jd-search.component.scss'],
    standalone: false
})
export class GenAiJdSearchComponent implements OnInit {

  @Input() description = "";
  @Input() calledFrom = "";
  private jdResponse: JdData = null;

  constructor(private activeModal: NgbActiveModal, private searchtoolbox: SearchtoolboxService, private aiSourcingService: AiSourcingService, private personSearchService: PersonSearchService,
    private jdService: JdDataService
  ) { }

  ngOnInit() { this.increaseProgress(); }

  progressValue: number = 0;

  increaseProgress() {

    const interval$ = interval(500); // Change interval duration as needed
    const subscription = interval$.subscribe(() => {
      this.progressValue += 10;
      if (this.progressValue >= 80) {
        this.progressValue = this.jdResponse ? 100 : 99;
      }
      if (this.progressValue === 100) {
        subscription.unsubscribe();
        setTimeout(() => this.activeModal.close(this.jdResponse), 500);
      }
    });

    if (this.description && this.calledFrom && this.calledFrom == 'ai-sourcing') {
      this.description && this.aiSourcingService.jdJSONDetails(this.description).subscribe((res: JdData) => {
        this.jdResponse = res;
      });
    } else if(this.description && this.calledFrom && this.calledFrom == 'nl-search') {
      const payload = {
        user_query: this.description
      }
      this.description && this.personSearchService.getNLSearchData(payload).subscribe((res: JdData) => {
        this.jdResponse = res;
      }, (error) => {
      if(error.status == 500) {
    this.description && this.searchtoolbox.jdParser(this.description).subscribe((res: JdData) => {
        this.jdResponse = res;
      });
      }
      });
    } else {
    this.description && this.searchtoolbox.jdParser(this.description).subscribe((res: JdData) => {
        this.jdResponse = res;
        this.jdService.setJdDescription(this.description);

      });
    }

    };

}

